module.exports = __webpack_public_path__ + "img/project4.9c0edbd4.jpeg";